import { SpinLoading as AntdMobileSpinLoading } from "antd-mobile";
import { BaseLoadingProps } from "./Loading.types";
import { SpinnerIcon } from "../../Icon/IconSvgMap";
import "./Loading.scss";

const AppSpinner = () => <SpinnerIcon className="loading__app-spinner" />;

export const Loading: React.FC<BaseLoadingProps> = ({
  children,
  spinning = true,
  tip,
  variant = "primary",
  size = "md",
  color = "default",
  className = "",
  testId,
  ...props
}) => {
  const loadingClass = [
    "loading",
    `loading--${variant}`,
    `loading--${size}`,
    spinning && "loading--spinning",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // Use app spinner for 'app' variant
  const useAppSpinner = variant === "app";

  if (children) {
    return (
      <div className={loadingClass} data-testid={testId}>
        {spinning && (
          <div className="loading__overlay">
            {useAppSpinner ? (
              <AppSpinner />
            ) : (
              <AntdMobileSpinLoading
                className="loading__spinner"
                color={color}
                {...props}
              />
            )}
            {tip && <div className="loading__tip">{tip}</div>}
          </div>
        )}
        {children}
      </div>
    );
  }

  return (
    <div className={loadingClass} data-testid={testId}>
      {useAppSpinner ? (
        <AppSpinner />
      ) : (
        <AntdMobileSpinLoading
          className="loading__spinner"
          color={color}
          {...props}
        />
      )}
      {tip && <div className="loading__tip">{tip}</div>}
    </div>
  );
};

export default Loading;
